module.exports = function(app) {
	"use strict";
  app
  .directive('sortableDir',sortableDir);
	sortableDir.$inject = [];
  function sortableDir() {
    return {
      require: '?ngModel',
      link: function(scope, element, attrs, ngModel) {
        if(attrs.type!="noOrder") {
          scope.$watch(function(){
            return ngModel.$modelValue
          }, function(newValue, oldValue){
            if (newValue!=oldValue) {
              for (var i=0; i<ngModel.$modelValue.length;i++) {
                ngModel.$modelValue[i].order = (attrs.type=="videoBox")? i: i+1;
              }
            }
          },true);
        }
        var options = {
          helper:'original',
          axis:'y',
          start: function(e, ui) {
            ui.item.directive = {
              start: ui.item.index(),
              startModel: ngModel
            };
          },
          update: function(e, ui) {
            var start = ui.item.directive.start;
            var end = ui.item.index();
            
            if (ui.item.closest('.ui-sortable')[0] === element[0]) {
              scope.$apply(function() {
                var element = ui.item.directive.startModel.$modelValue.splice(start, 1)[0];
                ngModel.$modelValue.splice(end, 0, element);
              });
            }
          }
        };
        element.sortable(options);
      }
    };
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/sortableDirective.js
// module id = 451
// module chunks = 0